/**
 * Internal test runs: open the site with ?test=1 and every assessment started in that
 * browser tab is saved as a test run (is_test_run), so the admin dashboard, exports and
 * norm calculations can leave it out. ?test=0 switches it off again. Real participants
 * never use the parameter, so their sessions are never flagged.
 */
const TEST_RUN_KEY = 'dystest_test_run';

export function syncTestRunFlagFromUrl(search: string): void {
  const value = new URLSearchParams(search).get('test');
  try {
    if (value === '1') sessionStorage.setItem(TEST_RUN_KEY, '1');
    else if (value === '0') sessionStorage.removeItem(TEST_RUN_KEY);
  } catch {
    // Storage unavailable (private mode): the session is simply not flagged.
  }
}

export function isTestRun(): boolean {
  try {
    return sessionStorage.getItem(TEST_RUN_KEY) === '1';
  } catch {
    return false;
  }
}
